export default __webpack_public_path__ + "static/media/AcIconOn.bd8fbe3f.svg";